module.exports = __webpack_public_path__ + "static/media/tile_menu_icon_rewards.706fffe7.png";